import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";

export const StyledRadioInput = styled.input`
  display: none;
`;

StyledRadioInput.displayName = "StyledRadioInput";

export const StyledRadioLabel = styled.label`
  ${tw`tw-inline-flex tw-items-center`}
`;

StyledRadioLabel.displayName = "StyledRadioLabel";

export interface IStyledRadioButton {
  $isHovered?: boolean;
  $isControlled?: boolean;
}

export const StyledRadioButton = styled.div<IStyledRadioButton>`
  ${BoxSizingStyle}
  ${tw`tw-inline-flex tw-items-center`}

  height: 16px;
  width: 16px;
  position: relative;

  svg {
    cursor: pointer;
    fill: transparent;
  }

  circle:first-child {
    transition-duration: 0.2s;
    stroke: var(--color-theme-500);
  }

  circle:last-child {
    transition-duration: 0.2s;
    transform-origin: center;
    transform: scale(0);
    fill: var(--color-secondary-500);
  }

  input:focus ~ ${StyledRadioLabel} {
    circle:first-child {
      stroke: var(--color-secondary);
    }
  }

  input:disabled ~ ${StyledRadioLabel} {
    pointer-events: none;
    opacity: 0.5;
  }

  ${(props) =>
    props.$isControlled !== true &&
    css`
      input:hover ~ ${StyledRadioLabel} {
        circle:first-child {
          stroke: var(--color-secondary);
        }
        circle:last-child {
          transform: scale(1);
        }
      }
    `}

  ${(props) =>
    props.$isHovered &&
    css`
      ${StyledRadioLabel} {
        circle:first-child {
          stroke: var(--color-secondary);
        }
        circle:last-child {
          transform: scale(1);
        }
      }
    `}

  input:checked ~ ${StyledRadioLabel} {
    circle:first-child {
      stroke: var(--color-secondary);
    }
    circle:last-child {
      transform: scale(1);
      fill: var(--color-secondary);
    }
  }
`;

StyledRadioButton.displayName = "StyledRadioButton";
